import { gql } from '@apollo/client';

export const GET_PROPOSALS_FOR_HUB_TABLE = gql`
  query ProposalsForHubTable {
    proposals {
      id
      status
      saleType
      lastName
      fullName
      firstName
      businessName
      salesPersonName
      createdDateTime
      amountRequested
      vendorOpportunityId
      vendorOpportunity {
        applicationStage
        paymentType
        salesRepresentative {
          firstName
          lastName
          fullName
        }
        financeManager {
          firstName
          lastName
          fullName
        }
        location {
          locationName
        }
        equipments {
          newUsed
        }
      }
    }
  }
`;
